import { IServerError } from 'utils/types';

export const checkIsDeactivatedError = (error: IServerError): boolean => error?.title === 'deactivated';
